<template>
  <div class="wrapper">
    <form @submit.prevent="update">
      <p v-show="!editing" @click="startEditing" class="label" :class="{'prewrap': textarea}">
        <span v-if="newValue.length == 0" class="placeholder">{{placeholder || 'Нажмите, чтобы редактировать'}}</span>
        <span>{{newValue}}</span>
      </p>
      <input v-show="editing" type="text" v-model="newValue" ref="firstInput" @keyup.esc="cancel" v-if="!textarea">
      <textarea v-show="editing" type="text" v-model="newValue" ref="firstInput" @keyup.esc="cancel" v-if="textarea" rows="5"></textarea>
      <i v-show="editing" @click="cancel">
        <font-awesome-icon icon="ban"/>
      </i>
      <i v-show="editing" @click="update" class="update">
        <font-awesome-icon icon="check"/>
      </i>
    </form>
  </div>
</template>

<script>
  export default {
    name: 'SmartInput',
    props: ['value', 'placeholder', 'width', 'textarea'],
    data () {
      return {
        editing: false,
        newValue: ''
      }
    },
    methods: {
      startEditing () {
        this.editing = true
        const newValue = this.newValue
        setTimeout(() => {
          this.$refs.firstInput.focus()
          if (!isNaN(newValue)) { // если число, выделяем весь текст
            this.$refs.firstInput.select()
          }
        }, 70)
      },
      update () {
        this.$emit('input', this.newValue)
        this.$emit('change', this.newValue)
        this.editing = false
      },
      cancel () {
        this.newValue = this.value
        this.editing = false
      },
      clear () {
        this.newValue = ''
      }
    },
    mounted () {
      this.newValue = this.value
    }
  }
</script>

<style scoped lang="scss">
  .wrapper {
    flex: 1;
    position: relative;
  }

  .label {
    cursor: pointer;
    border-bottom: 1px solid transparent;
    margin: 0;
    padding: 2px 0;
    min-height: 1em;
    &.prewrap {
      white-space: pre-wrap;
    }
    &:hover {
      border-bottom: 1px solid $blue;
    }
    .placeholder {
      color: #b4b4b4;
      font-style: italic;
    }
  }

  input {
    min-width: 100px;
    position: relative;
    z-index: 10;
  }

  input, textarea {
    display: block;
    width: 100%;
    padding: 4px 60px 4px 7px;
    font-size: 14px;
    font-family: inherit;
  }

  i {
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    padding: 10px;
    z-index: 11;
    &.update {
      right: 30px;
    }
    &:hover {
      path {
        fill: $blue;
      }
    }
    path {
      fill: $light-blue;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SmartInput.vue